import { createFileRoute, useLocation, useNavigate } from '@tanstack/react-router'
import { Box, Button, IconButton, InputAdornment, styled, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import CategoryCard from '@components/CategoryCard/CategoryCard.component'
import AddIcon from '@mui/icons-material/Add'
import ReusableModal from '@components/Modal/ReusableModal.component'
import { Android } from '@mui/icons-material'
import SearchIcon from 'icons/Search.icon'
import { useMutation, useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { toast } from 'react-toastify'

export const Route = createFileRoute(
  '/(partner)/_partner/interview-genarator-step2',
)({
  component: RouteComponent,
})

const StyledSearch = styled(TextField)(() => ({
  marginTop: '24px',
  input: {
    lineHeight: '20px',
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--Interviewer-Lightest-Black)',
  },
}))

function RouteComponent() {

    // Prikupljanje podataka is state
    const location = useLocation().state
    const [categories, setCategories] = useState(location.categories);
    const { techId } = location

    const navigate = useNavigate();
    
    const [modalNewCategory, setModalNewCategory] = useState(false)
    const [searchTerm, setSearchTerm] = useState("");



    // Prikupljanje postojecih kategorija za modal
    const {data: existingCategories} = useQuery({
        queryKey: ['modal-existing-categories', searchTerm],
        queryFn: async () => {
            const token = localStorage.getItem('token');
            const response = await axios.get(`https://interviewer.runasp.net/api/technologies/${techId}/categories/scale/search`, {
                params: {searchTerm},
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            return response.data
        },
        enabled: !!modalNewCategory
    })


    // Dodavanje kategorije iz modala
    const addCategory = (category) => {
        setCategories(prev => [...prev, category]);
    }

    const handleUpdateCategoryQuestions = () => {
        console.log(123);
    }

    const handleRemoveCategory = (id) => {
        setCategories(prev => prev.filter(category => category.id !== id));
    }


    // Slanje kategorija klikom na dugme Next
    const submitCategoriesMutation = useMutation({
        mutationFn: async (data) => {
            const token = localStorage.getItem('token');
            const response = await axios.post('https://interviewer.runasp.net/api/categories/advanced-generator/categories', data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            return response;
        },
        onSuccess: (data) => {
            navigate({
                to: '/question-selector',
                state: {questions : data}
            })
        },
        onError: (error) => {
            toast.error('Error, please check again!')
            console.log(error);
        }
    })
    const handleNextButton = () => {
        const payload = {
            scaleParams: categories.map(category => ({
                id: category.id,
                numberOfQuestions: category.recommendedNumberOfQuestions || category.totalNumberOfQuestions || 0
            }))
        };
        if(payload.scaleParams.length < 1) {
            toast.error('Please add at least one category!')
        }else {
            submitCategoriesMutation.mutate(payload)
        }
    }

      return <Box>
        <Box sx={{display: 'flex', flexDirection: 'column', gap: '12px', mx: 'auto', maxWidth: {xs: '100%', md: '80%'}, textAlign: 'center', pb: '32px'}}>
            <Typography variant="h1">
                Customize your interview
            </Typography>
            <Typography sx={{fontSize: '16px'}}>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </Typography>
        </Box>

        <Box sx={{display: 'flex', flexDirection: 'column', gap: '24px'}}>
            {categories && 
                categories.map((category, index) => (
                    <CategoryCard 
                        key={index}
                        id={category.id}
                        title={category.name}
                        description={category.description}
                        recommendedQuestions={category.recommendedNumberOfQuestions}
                        onRemove={() => handleRemoveCategory(category.id)}
                        onQuestionsChange={handleUpdateCategoryQuestions}
                    />
                ))
            }
        </Box>


        <Box
            sx={{
            mt: '24px',
            my: '32px',
            border: '2px dashed var(--Light-Gray)',
            borderRadius: '20px',
            padding: '40px',
            textAlign: 'center',
            }}
        >
            <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            >
            <IconButton
                onClick={() => setModalNewCategory(true)}
                sx={{
                borderRadius: '16px',
                boxShadow: '0px 1px 2px 0px #0205111A',
                width: '64px',
                height: '64px',
                mb: '16px',
                '&:hover': {
                    backgroundColor: 'var(--Light-Gray)',
                },
                }}
            >
                <AddIcon sx={{ fontSize: '32px', color: '#000000' }} />
            </IconButton>
            <Typography
                variant="h3"
                sx={{ color: 'var(--Interviewer-Lighter-Black)' }}
            >
                Add a category
            </Typography>
            </Box>
        </Box>

        <Button variant='contained' onClick={() => handleNextButton()} sx={{display: 'flex', width: '80%', mx: 'auto'}}>Next</Button>

        {/* Modal za kategorije */}
        <ReusableModal open={modalNewCategory} onClose={() => setModalNewCategory(false)}>

            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '26px'}}>
                <Android />
                <Box sx={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                    <Typography variant='h1'>Add a category</Typography>
                    <Typography variant='h4'>Add a category from the list or search for a specific category</Typography>
                </Box>
            </Box>

            <StyledSearch
                fullWidth
                type="search"
                value={searchTerm}
                onChange={(event) => setSearchTerm(event.target.value)}
                slotProps={{
                    input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    },
                }}
                placeholder="Search for a category"
            />
           
            <Box sx={{display: 'flex', flexDirection: 'column', gap: '8px', mt: '20px'}}>
                {existingCategories?.map((category) => {
                    // const isLinked = categories.includes(category.id);
                    const isLinked = categories.some(c => c.id === category.id);
                    return (
                        <Box key={category.id} sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            p: { xs: 1.5, sm: 2 },
                            border: '1px solid var(--Light-Gray)',
                            borderRadius: '8px',
                            opacity: isLinked ? 0.5 : 1,
                        }}>
                            <Box>
                                <Typography variant="h3" sx={{pb: '8px'}}>{category.name}</Typography>
                                <Typography sx={{fontSize: '14px'}}>{category.description}</Typography>
                            </Box>
                            <IconButton
                                color="primary"
                                onClick={() => addCategory(category)}
                                disabled={isLinked}
                                sx={{
                                    backgroundColor: 'black',
                                    color: 'white',
                                    borderRadius: '50%',
                                    p: '8px',
                                    width: '40px',
                                    height: '40px',
                                    '&:hover': {
                                    backgroundColor: 'var(--Light-Gray)',
                                    },
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                >
                                <AddIcon />
                            </IconButton>
                        </Box>
                    )
                })}
            </Box>
        </ReusableModal>
    </Box>
}
